import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/custom-buttons.css';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundaryFallback from './components/ErrorBoundaryFallback';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
    <App />
  </ErrorBoundary>,
);

reportWebVitals();
